import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import {TokenStorage} from "../token-storage.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private tokenStorage: TokenStorage,
    ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const token: string = <string>localStorage.getItem('authentication-token');
        if (token) {
            const authReq = req.clone({
                headers: req.headers.set('Auth-Token', token)
            });
            return next.handle(authReq);
        }
        return next.handle(req);
    }
}
